import { render } from "./ModalWithdrawOtonAcept.vue?vue&type=template&id=6a33f7ca&scoped=true&ts=true"
import script from "./ModalWithdrawOtonAcept.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawOtonAcept.vue?vue&type=script&lang=ts"

import "./ModalWithdrawOtonAcept.vue?vue&type=style&index=0&id=6a33f7ca&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a33f7ca"]])

export default __exports__